const ProgressBar = () => (
  <div className="progress-bar">
    <div className="progress-amount" />
  </div>
);

export default ProgressBar;
